import { queryOptions } from '@tanstack/react-query';
import { BaseApiResponse, WebinarContentSummary } from './Api';
import { ApiQueryOptions, apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const WebinarsApi = {
    getMyUpcoming: (options?: BaseApiQueryOptions) => apiQueryOptions(['webinars', 'getMyUpcoming'], (api) => api.webinars.getMyUpcoming(), options),
    getMyEnded: (options?: BaseApiQueryOptions) => apiQueryOptions(['webinars', 'getMyEnded'], (api) => api.webinars.getMyEnded(), options),
    getUpcoming: (params?: BaseApiQueryOptions) => apiQueryOptions(['webinars', 'getUpcoming'], (api) => api.webinars.getUpcoming(), params),
    getOnDemand: (params?: BaseApiQueryOptions) => apiQueryOptions(['webinars', 'getOnDemand'], (api) => api.webinars.getOnDemand(), params),

    /**
     * The signed-in account's upcoming webinars, or an empty list for a visitor without asking the
     * backend, which would answer 401. The visitor's entry has its own key so the two can never
     * share a cache slot.
     */
    getMyUpcomingOrNone: (isAuthenticated: boolean, options?: BaseApiQueryOptions) =>
        isAuthenticated
            ? WebinarsApi.getMyUpcoming(options)
            : (queryOptions<WebinarContentSummary[], BaseApiResponse, WebinarContentSummary[], string[]>({
                  queryKey: ['webinars', 'getMyUpcoming', 'visitor'],
                  queryFn: () => Promise.resolve([]),
                  staleTime: Infinity,
                  // The caller's options apply to this branch too, so a screen configures one query,
                  // not two that behave differently depending on who is looking.
                  ...options
              }) as ApiQueryOptions<WebinarContentSummary[], string[]>)
};
